import { render, staticRenderFns } from "./TbcpIndex.vue?vue&type=template&id=09e07da6&scoped=true&"
import script from "./TbcpIndex.vue?vue&type=script&lang=js&"
export * from "./TbcpIndex.vue?vue&type=script&lang=js&"
import style0 from "./TbcpIndex.vue?vue&type=style&index=0&id=09e07da6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e07da6",
  null
  
)

export default component.exports